export const enum AppPaths {
    PRESENT = "/present",
    PRESENT_PERFECT = "/present_perfect",
    PAST_SIMPLE = "/past_simple",
    PAST_PROGRESSIVE = "/past_progressive",
    PAST_PERFECT = "/past_perfect",
    IMPERATIVE = "/imperative",
    SUBJUNCTIVE = "/subjunctive",
    SIMPLE_FUTURE = "/simple_future",
    FUTURE_PERFECT = "/future_perfect",
    POSSESSIVE = "/possessive",
    PRONOUNS = "/pronouns",
    CONDITIONAL = "/conditional",
    REFLEXIVE = "/reflexive",
    VOZ = "/voz",
    QUIZ = "/quiz",
    TOPICS = "/topics",
    AUTH = "/auth"
}